<h1>Dahboard</h1>
<div>
    <mat-card>6</mat-card>
</div>